import React from 'react';
import { useT } from '../BuilderApp.jsx';
import WizardShell from '../WizardShell.jsx';
import { CheckIcon } from '../../components/ui/Icons.jsx';
import { PACKAGES, PKG_TEXT, ADDONS } from '../../data/packages.js';
import { tmplById, pkgById } from '../../data/defaults.js';

export default function Step8Review({ config, setField, next, back, lang, setLang, agreed, setAgreed, onBuild }) {
  const t = useT();
  const tmpl = tmplById(config.template);
  const pkg = pkgById(config.package);
  const pkgIdx = PACKAGES.findIndex(p => p.id === pkg.id);
  const pd = t.pkgs[pkgIdx];
  const domain = config.custom_domain || (config.slug ? `${config.slug}.chamcore.site` : '—');


  const addons = config.addons.map(id =>
    ADDONS.find(addon => addon.id === id)
  ) || [];

  const addonTotal = addons.reduce((sum, addon) => sum + addon.eur,0);
  const rows = [
    { label: t.s7_template, value: `${tmpl.icon} ${tmpl.label}` },
    { label: t.s7_business, value: config.branding.company_name || '—' },
    { label: t.s7_plan, value: `${pkg.label} — ${pd.price}` },
    { label: t.s7_monthly, value: addons.length > 0 ? `€${addonTotal}` : `${pkg.monthly}` },
    { label: t.s7_domain, value: domain },
  ];

  return (
    <WizardShell step={8} total={8} title={t.s7_title} subtitle={t.s7_sub} onBack={back} lang={lang} setLang={setLang}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>

        {/* Summary table */}
        <div className="glass" style={{ borderRadius: 14, overflow: 'hidden' }}>
          <div style={{ background: 'rgba(255,255,255,.04)', padding: '.75rem 1rem', fontSize: '.72rem', fontWeight: 700, color: 'var(--muted)', letterSpacing: '.07em', textTransform: 'uppercase', borderBottom: '1px solid var(--border)' }}>
            {t.s7_summary}
          </div>
          {rows.map((r, i) => (
            <div key={r.label} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '.72rem 1rem', borderBottom: i < rows.length - 1 ? '1px solid var(--border)' : undefined }}>
              <span style={{ fontSize: '.81rem', color: 'var(--muted)' }}>{r.label}</span>
              <span style={{ fontSize: '.81rem', fontWeight: 600 }}>{r.value}</span>
            </div>
          ))}
        </div>

        {/* Starter billing note */}
        {pkg.id === 'starter' && (
          <div style={{ background: 'rgba(52,211,153,.06)', border: '1px solid rgba(52,211,153,.18)', borderRadius: 12, padding: '.9rem 1rem', display: 'flex', gap: '.65rem' }}>
            <span style={{ fontSize: '.95rem', flexShrink: 0 }}>💳</span>
            <div style={{ fontSize: '.79rem', lineHeight: 1.55 }}>
              <strong style={{ color: 'var(--green)' }}>{t.s7_bill_title}</strong><br />
              <span style={{ color: 'var(--muted)' }}>{t.s7_bill_text}</span>
            </div>
          </div>
        )}

        {/* Terms checkbox */}
        <label
          style={{ display: 'flex', alignItems: 'flex-start', gap: '.75rem', cursor: 'pointer', padding: '.9rem 1rem', borderRadius: 12, border: '1px solid var(--border)', background: 'rgba(255,255,255,.02)' }}
          onClick={() => setAgreed(v => !v)}
        >
          <div className={`checkbox${agreed ? ' checked' : ''}`} style={{ marginTop: '.05rem' }}>
            {agreed && <CheckIcon size={11} color="#fff" />}
          </div>
          <span style={{ fontSize: '.81rem', color: 'var(--muted)', lineHeight: 1.55 }}>
            {t.s7_agree} <span style={{ color: 'var(--blue2)' }}>{t.s7_tos}</span> {t.s7_and} <span style={{ color: 'var(--blue2)' }}>{t.s7_pp}</span>{t.s7_agree_end}
          </span>
        </label>

        <button className="btn btn-primary btn-lg btn-full" onClick={onBuild} disabled={!agreed}>
          {t.s7_build}
        </button>
        <p style={{ textAlign: 'center', fontSize: '.73rem', color: 'var(--dim)' }}>{t.s7_fine}</p>
      </div>
    </WizardShell>
  );
}
